// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--2dWT3","page":"styles-module--page--1Ratj","content":"styles-module--content--RpADO"};